import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../SettingsHeader";
import CannedResponse from "./CannedResponse";

import {cannedResponse} from "../../../actions/actions"


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class CannedResponses extends Component {

    constructor(props) {
        super(props);
        this.state={
            "showMenu":false,
            "removeMenu":false,
            "shortcut_value":"",
            "response_value":"",
            "button_disabled":true
        }
        this.onMouseOver=this.onMouseOver.bind(this);
        this.onMouseOut=this.onMouseOut.bind(this);
        this.removeMenu=this.removeMenu.bind(this);
        this.removeMenuClose=this.removeMenuClose.bind(this);
        this.addResponse=this.addResponse.bind(this);
        this.onchangeResponse=this.onchangeResponse.bind(this);
        this.onchangeShortcut=this.onchangeShortcut.bind(this);
    }

    onchangeResponse(e){
        this.setState({
            "response_value":e.target.value.trim()
        });
        if(e.target.value.trim().length>0 && this.state.shortcut_value.trim().length>0){
            this.setState({
                "button_disabled":false
            })
        } else{
            this.setState({
                "button_disabled":true
            })
        }
    }
    onchangeShortcut(e){
        this.setState({
            "shortcut_value":e.target.value.trim()
        });
        if(e.target.value.trim().length>0 && this.state.response_value.trim().length>0){
            this.setState({
                "button_disabled":false
            })
        } else{
            this.setState({
                "button_disabled":true
            })
        }
    }
    addResponse(){
        if(this.state.response_value.trim().length>0 && this.state.shortcut_value.trim().length>0){
            this.props.dispatch(cannedResponse({
                action:"add",
                shortcut:this.state.shortcut_value.trim(),
                desc:this.state.response_value.trim()
            }));
        }
    }
    onMouseOver(){

        this.setState({
            "showMenu":true,

        })
    }
    removeMenuClose(){
        this.setState({
            "removeMenu":false,

        })
    }
    removeMenu(){
        this.setState({
            "removeMenu":true,

        })
    }
    onMouseOut(){
        this.setState({
            "showMenu":false,

        })
    }
    componentDidMount() {

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <SettingsHeader title="Canned Responses"/>
                <div className="settings-center-wrap canned-responses-wrap">
                    <div className="settings-code-block settings-code-block-clean ">


                        <h6 className=" title canned-responses-h6">What are canned responses</h6>
                        <p className="description">
                            Canned responses are pre-made messages you can recall easily during chat.
                        </p>

                        <div className="canned-responses-form">
                            <div className="form">
                                    <div>
                                        <textarea
                                            onChange={this.onchangeResponse.bind(this)}
                                            className="form-control"
                                            placeholder="Canned response text...">{this.state.response_value}</textarea>
                                    </div>
                                    <div>
                                       <input
                                           value={this.state.shortcut_value}
                                           onChange={this.onchangeShortcut.bind(this)}
                                           type="text"
                                              className="form-control"
                                           placeholder="Shortcut..."/>
                                    </div>
                            </div>

                            <div className="submit">
                                    <button className={"btn btn-primary btn-sm "+(this.state.button_disabled===true ? "disabled" : "")}
                                            onClick={this.addResponse.bind(this)}>
                                        Add this response
                                    </button>
                            </div>
                        </div>

                        <div className="canned-responses-list">

                            {Object.keys(this.props.chatprop.canned_response).map((m)=>{
                               return  <CannedResponse data={this.props.chatprop.canned_response[m]}/>
                            })}




                        </div>


                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CannedResponses;
